import { render, staticRenderFns } from "./ServiceVisitBoardCardTasks.vue?vue&type=template&id=c3d9b962&scoped=true&"
import script from "./ServiceVisitBoardCardTasks.vue?vue&type=script&lang=js&"
export * from "./ServiceVisitBoardCardTasks.vue?vue&type=script&lang=js&"
import style0 from "./ServiceVisitBoardCardTasks.vue?vue&type=style&index=0&id=c3d9b962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d9b962",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
